import { useEffect, useState } from "react";

export default function ToTop() {

    const [visible, setVisible] = useState(false);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 100) {
            setVisible(true)
        } else if (scrolled <= 100) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisible);
    }, [])

    return (
        <div className="fixed bg-LayananBtn hover:bg-hoverColor w-[50px] h-[50px] rounded-[50%] flex justify-center items-center right-[1rem] lg:right-[4rem]
        bottom-[3rem] lg:bottom-[4rem] toTop cursor-pointer" style={{ display: visible ? 'flex' : 'none' }} onClick={scrollToTop}>
                <img src="https://res.cloudinary.com/alcottimg/image/upload/v1660549833/Website%20Alcott%20Smg/Icon/Kanan-W_oedirr.png" className="rotate-[270deg] h-7" />
        </div>
    )
}